<template>

  <v-dialog
    v-model="shown"
    :width="600"
    :persistent="true"
    :fullscreen="fullscreen"
  >
    <v-card dark v-if="shown" class="c-d-flex c-flex-column" :class="fullscreen ? 'fill-height scrollable' : null">
      <div :style="{height: !fullscreen ? '500px' : ''}" class="c-flex-grow-1">
        
        <div class="monaco-editor-container" style="width: 100%; height: 100%" id="codeEditor">
        
        </div>
        
      </div>
      <v-divider></v-divider>
      <div class="pb-1 c-d-flex c-align-center c-justify-end">

<!--        <div class="caption white&#45;&#45;text pa-2">-->
<!--          *Right click to add a field-->
<!--        </div>-->
        <div>
          <v-btn
            dark
            @click="$emit('dismiss')"
            small
            flat
            class="pa-0 mr-2"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="done()"
            color="secondary"
            small
            class="pa-0"
          >
            Done
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>

export function oldEvalConversion(evalString) {
  evalString = (evalString || '').replace(/\\"/g,`"`)
      .replace(/&amp;/gm,`&`)
      .replace(/&lt;/gm,`<`)
      .replace(/&gt;/gm,`>`)
      .replace(/&nbsp;/gm,` `)
  
  const wfFieldsReg = /<div[^(<)]+f-W-V-\d+">[^>]+<\/div>/g
  const wfFieldIDExtractReg = /(?<=f-W-V-)\d+/g
  const wfFieldStrings = evalString.match(wfFieldsReg) || []
  
  for (const fieldStr of wfFieldStrings) {
    const fieldId = fieldStr.match(wfFieldIDExtractReg)?.at(-1)
    if (fieldId) {
      evalString = evalString.replace(fieldStr, "f-W-V-" + fieldId)
    } else {
      evalString = evalString.replace(fieldStr, '!!! UNKNOWN FIELD !!!')
    }
  }
  
  const dsFieldsReg = /<div[^(<)]+f-D-V-\d+-\d+">[^(<)]+<\/div>/g
  const dsFieldIDExtractDsSfIdReg = /(?<=f-D-V-)\d+/g
  const dsFieldIDExtractDsFIdReg = /(?<=-)\d+/g
  
  const dsFieldStrings = evalString.match(dsFieldsReg) || []
  
  for (const fieldStr of dsFieldStrings) {
    const selectFieldId = fieldStr.match(dsFieldIDExtractDsSfIdReg)?.at(-1)
    const fieldId = fieldStr.match(dsFieldIDExtractDsFIdReg)?.at(-1)
    
    if (fieldId) {
      evalString = evalString.replace(fieldStr, `f-D-V-${selectFieldId}-${fieldId}`)
    } else {
      evalString = evalString.replace(fieldStr, '!!! UNKNOWN FIELD !!!')
    }
  }
  
  return evalString.split('<div>').join('\n').split('</div>').join('').split('<br>').join(`\n`).split('&nbsp;').join(' ');
}

export function replaceFieldRefs(evalString, workflowFields, datasetFields) {
  const wfFieldsReg = /f-W-V-\d+/g
  const wfFieldIDExtractReg = /\d+/g
  const wfFieldStrings = evalString.match(wfFieldsReg)
  
  for (const fieldStr of wfFieldStrings) {
    const fieldId = fieldStr.match(wfFieldIDExtractReg)?.at(-1)
    const workflowField = workflowFields.find(v => v.id?.toString() === fieldId)
    
    if (fieldId && workflowField) {
      evalString = evalString.replace(fieldStr, 'workflowFields.' + replaceFieldName(workflowField.description + ' ' + workflowField.id))
    } else {
      evalString = evalString.replace(fieldStr, 'workflowFields.!!! UNKNOWN FIELD !!!')
    }
  }
  
  const dsFieldsReg = /f-D-V-\d+-\d+/g
  const dsFieldIDExtractDsSfIdReg = /(?<=f-D-V-)\d+/g
  const dsFieldIDExtractDsFIdReg = /(?<=-)\d+/g

  const dsFieldStrings = evalString.match(dsFieldsReg) || []

  for (const fieldStr of dsFieldStrings) {
    
    const selectFieldId = fieldStr.match(dsFieldIDExtractDsSfIdReg)?.at(-1)
    
    const workflowSelectField = workflowFields.find(v => v.id?.toString() === selectFieldId)
    const dataset = datasetFields.find(v => v.id?.toString() === workflowSelectField?.config?.dataset)
    
    const datasetFieldId = fieldStr.match(dsFieldIDExtractDsFIdReg)?.at(-1)
    
    const datasetField = dataset?.fields.find(v => v.id?.toString() === datasetFieldId)
    
    if (workflowSelectField && datasetField) {
      evalString = evalString.replace(fieldStr, `${replaceFieldName(workflowSelectField.description)}.${replaceFieldName(datasetField.description)}_${datasetField.id}`)
    } else {
      evalString = evalString.replace(fieldStr, '!!! UNKNOWN FIELD !!!')
    }
  }
  
  return evalString
}

export function replaceFieldNames(evalString, workflowFields, datasetFields) {
  
  const wfFieldIdRef = new Map(workflowFields.map(v => ["workflowFields." + replaceFieldName(v.description) + "_" + v.id, 'f-W-V-' + v.id]))
  
  const wfFieldsReg = /workflowFields\.[A-Za-z_0-9]+/g
  const wfFieldStrings = evalString.match(wfFieldsReg) || []
  
  for (const fieldStr of wfFieldStrings) {
    
    const refId = wfFieldIdRef.get(fieldStr)

    if (refId) {
      evalString = evalString.replaceAll(fieldStr, refId)
    } else {
      evalString = evalString.replaceAll(fieldStr, '!!! UNKNOWN FIELD !!!')
    }
  }
  
  for (const dsSelectField of workflowFields.filter(v => v.fieldType === 9)) {
    const dataset = datasetFields.find(v => v.id?.toString() === dsSelectField?.config?.dataset)
    const dsFieldsReg = new RegExp(`${replaceFieldName(dsSelectField.description)}\\.[A-Za-z_0-9]+`, 'g')
    const dsFieldStrings = evalString.match(dsFieldsReg) || []
    
    const dsFieldIdRef = new Map((dataset?.fields || []).map(v => [`${replaceFieldName(dsSelectField.description)}.${replaceFieldName(v.description)}_${v.id}`, `f-D-V-${dsSelectField.id}-${v.id}`]))
    
    for (const field of dsFieldStrings) {
      const refId = dsFieldIdRef.get(field)
      
      if (refId) {
        evalString = evalString.replaceAll(field, refId)
      } else {
        evalString = evalString.replaceAll(field, '!!! UNKNOWN FIELD !!!')
      }
    }
  }
  
  return evalString
}

function replaceFieldName(str) {
  if (typeof str !== 'string') {
    throw new TypeError('Input must be a string');
  }
  return str
      .replace(/^\d/,'_$&')
      .replaceAll('/','_')
      .replaceAll('?','')
      .replaceAll('.','_')
      .replaceAll('(','_')
      .replaceAll(')','_')
      .replaceAll('-','_')
      .replaceAll('&','and')
      .replaceAll(' ', '_');
}


import InputDlg from "../../../../../../../../components/General/InputDlg";
import {codeBaseMixin} from "../../../../../../../../codeBaseMixin";
import FieldSetFieldSelector from "../../FieldSetFieldSelector";
import loader from "@monaco-editor/loader";

export default {
  mixins: [codeBaseMixin],
  components: {
    appFieldSetFieldSelector: FieldSetFieldSelector,
    appInputDlg: InputDlg
  },
  props: {
    value: String,
    localData: Object,
    userInfo: Object,
    shown: Boolean,
    steps: Array,
    fieldSets: Array,
    fields: Array,
  },
  data() {
    return {
      modelValue: this.value,
      editor: null,
      showSelectMenu: false,
      showWorkflowMenu: false,
      showDatasetMenu: false,
      selectedDatasetField: null,
      showUserInput: false,
      x: 0,
      y: 0,
      range: null,
      charCount: "",
      fullscreen: true
    }
  },
  beforeDestroy() {
    // Dispose of the Monaco editor instance
    if (this.editor) {
      this.editor.dispose(); // Properly destroy the editor instance
      this.editor = null; // Remove the reference
    }
    
    // Dispose of the Monaco model if it exists
    const model = monaco.editor.getModel(monaco.Uri.parse("ts:filename/facts.d.ts"));
    if (model) {
      model.dispose(); // Removes the model from Monaco's memory
    }
  },
  
  mounted() {
    const vm = this;
    loader.init().then((monaco) => {
      const editorOptions = {
        language: "javascript",
        minimap: { enabled: false },
        value: vm.modelValue,
        roundedSelection: false,
        scrollBeyondLastLine: false,
        readOnly: false,
        theme: "vs-dark",
      };
      
      // validation settings
      monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
        noSemanticValidation: true,
        noSyntaxValidation: false,
      });

// compiler options
      monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
        target: monaco.languages.typescript.ScriptTarget.ES2015,
        allowNonTsExtensions: true,
      });
      
// extra libraries
      let libSource = [
          `declare enum workflowFields {\n\t${vm.workflowFieldEditorRefs.join(',\n\t')}\n}`,
          this.datasetFieldEditorRefs.map(dset => `declare enum ${dset.selectField} {\n\t${(dset.fields || []).join(`,\n\t`)}\n}`),
      ].join('\n\n')
      
      let libUri = "ts:filename/facts.d.ts";
      
      monaco.languages.typescript.javascriptDefaults.addExtraLib(libSource, libUri);
// When resolving definitions and references, the editor will try to use created models.
// Creating a model for the library allows "peek definition/references" commands to work with the library.
      monaco.editor.createModel(libSource, "typescript", monaco.Uri.parse(libUri));
      
      
      vm.editor = monaco.editor.create(
          document.getElementById("codeEditor"),
          editorOptions
      );
      
      
    });
    
    
    
    // this.$refs.editor.addEventListener("paste", function(e) {
    //   // cancel paste
    //   e.preventDefault();
    //
    //   // get text representation of clipboard
    //   var text = (e.originalEvent || e).clipboardData.getData('text/plain');
    //
    //   // insert text manually
    //   document.execCommand("insertHTML", false, text);
    // });
  },
  watch: {
    
    value: {
      immediate: true,
      handler(val) {
        this.modelValue = replaceFieldRefs(oldEvalConversion(this.modelValue), this.fields, this.fieldSets)
      }
    },
  },
  methods: {
    // conversion() {
    //   console.log('Hello')
    //   console.log(
    //       replaceFieldNames(
    //           replaceFieldRefs(
    //               oldEvalConversion(this.modelValue), this.fields, this.fieldSets
    //           ), this.fields, this.fieldSets
    //       )
    //   )
    // },

    done() {
      if (this.editor) {
        let code = this.editor.getValue();
        let replacedCode = replaceFieldNames(code, this.fields, this.fieldSets)
        console.log(replacedCode)
        this.$emit('input', replacedCode)
        this.$emit('dismiss')
      } else {
        console.error("Editor is not initialized yet.");
        return null;
      }
    },
  },

  computed: {
    selectDatasetFieldNotReady() {
      return this.selectedDatasetField === null || typeof this.selectedDatasetField.field == 'undefined' || typeof this.selectedDatasetField.fieldSetSelectField == 'undefined';
    },

    workflowFields() {
      let tFields = this.fields
        .filter(obj => obj.visible === 1 && [1,2,3,4,5,22].includes(obj.fieldType))
        .sort((a,b) => a['field_order'] < b['field_order'] ? -1 : 1);
      let tStepIDs = tFields.map(obj => {return obj.fk_step});
      let tSteps = this.steps
        .filter(item => tStepIDs.includes(item.id) && item.hidden === 0)
        .sort((a,b) => a['field_order'] < b['field_order'] ? -1 : 1);

      let tList = tSteps.reduce((list, item) => {
        list.push({
          id: item.id,
          type: 'step',
          description: item.description
        });
        list = list.concat(tFields
          .filter(obj => obj.fk_step === item.id)
          .map(obj => {
            return {
              id: obj.id,
              description: obj.description,
              type: 'field',
              fk_step: obj.fk_step
            }
          })
        );
        return list;
      },[]);
      return tList
    },
    
    workflowFieldEditorRefs() {
      return this.workflowFields.map(v => `${replaceFieldName(v.description)}_${v.id}`)
    },
    
    datasetFieldEditorRefs() {
      console.log(this.fieldSets)
      return this.fields.filter(v => v.fieldType === 9)
          .map(dsSelectField => ({
            selectField: replaceFieldName(dsSelectField.description),
            fields: this.fieldSets.find(v => (v.id?.toString() || null) === (dsSelectField.config.dataset?.toString() || null))?.fields
                .filter(obj => obj.visible === 1 && [1,2,3,4,5,22].includes(obj.type))
                .map(v => replaceFieldName(v.description) + '_' + v.id)
          }))
    }
  }
}
</script>

<style scoped>
[contenteditable] {
  outline: 0px solid transparent;
}

.eval-editor {
  background: rgb(50,50,50);
  color: white;
  font-family: monospace;
  white-space: pre-wrap
}
</style>


